export default __webpack_public_path__ + "static/media/les_andelys01min.23a8d922.jpg";